import {useEffect,useState} from 'react';
import {Button,Modal,ModalContent,ModalHeader,ModalBody,ModalFooter} from '@nextui-org/react';
import {apiFetch} from '../lib/api';
import es from '../../../renderer/i18n/locales/es.json';

export default function RobloxBinding({uid}) {
  const [robloxId,setRobloxId]=useState('');
  const [busy,setBusy]=useState(true);
  const [error,setError]=useState('');
  const [confirm,setConfirm]=useState(false);
  const endpoint='/api/backoffice/users/'+encodeURIComponent(uid)+'/roblox';
  useEffect(()=>{
    let disposed=false;setBusy(true);setError('');setRobloxId('');setConfirm(false);
    apiFetch(endpoint).then(result=>{if(!disposed)setRobloxId(result.robloxId||'');}).catch(e=>{if(!disposed)setError(e.message);}).finally(()=>{if(!disposed)setBusy(false);});
    return ()=>{disposed=true;};
  },[endpoint]);
  async function unlink(){
    setBusy(true);setError('');
    try{await apiFetch(endpoint,{method:'DELETE',body:{robloxId}});setRobloxId('');setConfirm(false);}
    catch(e){setError(e.message);}
    finally{setBusy(false);}
  }
  return <section className="rounded-lg border border-default-200 bg-content1 p-4">
    <div className="flex items-center justify-between gap-4">
      <div><h2 className="text-lg font-semibold">Roblox</h2><label>{es.rb_id}<input className="block rounded border border-default-300 bg-default-100 p-2 mt-2" aria-label={es.rb_id} inputMode="numeric" value={robloxId} disabled={busy} onChange={event=>setRobloxId(event.target.value.replace(/\D/g,'').slice(0,16))} /></label></div>
      <Button color="danger" variant="flat" isDisabled={!robloxId||busy} onPress={()=>setConfirm(true)}>{es.rb_unlink}</Button>
    </div>
    {error&&<p role="alert" className="text-danger mt-3">{error}</p>}
    <Modal isOpen={confirm} onOpenChange={open=>{if(!busy)setConfirm(open);}} isDismissable={!busy} isKeyboardDismissDisabled={busy}>
      <ModalContent><ModalHeader>{es.rb_unlink} · Roblox</ModalHeader><ModalBody><p>{uid}</p><p>{es.rb_id}: <strong>{robloxId}</strong></p>{error&&<p role="alert">{error}</p>}</ModalBody><ModalFooter>
        <Button isDisabled={busy} onPress={()=>setConfirm(false)}>{es.common_cancel}</Button>
        <Button color="danger" isLoading={busy} onPress={unlink}>{es.rb_unlink}</Button>
      </ModalFooter></ModalContent>
    </Modal>
  </section>;
}
